
import { User } from "lucide-react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Header = () => {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const pageTitles = {
    "/dashboard": "Dashboard",
    "/messages": "Messages",
    "/logs": "Logs",
  };

  const pageTitle = pageTitles[location.pathname] || "Dashboard";

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <header className="relative z-20 flex items-center justify-between bg-white px-6 py-4 shadow">
      <h2 className="text-xl font-semibold text-primary">
        {pageTitle}
      </h2>

      <div className="relative">
        <button
          type="button"
          onClick={() => setShowMenu((previous) => !previous)}
          className="rounded-full p-2 text-primary transition-colors hover:bg-gray-100 hover:text-accent"
          aria-label="Open user menu"
          aria-expanded={showMenu}
        >
          <User size={24} />
        </button>

        {showMenu && (
          <>
            <button
              type="button"
              className="fixed inset-0 z-10 cursor-default"
              aria-label="Close user menu"
              onClick={() => setShowMenu(false)}
            />

            <div className="absolute right-0 z-20 mt-2 w-36 overflow-hidden rounded-lg border border-gray-200 bg-white py-1 text-sm shadow-lg">
              <button
                type="button"
                onClick={() => {
                  setShowMenu(false);
                  handleLogout();
                }}
                className="w-full px-4 py-2 text-left text-gray-700 transition-colors hover:bg-gray-100 hover:text-primary"
              >
                Logout
              </button>
            </div>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
